import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TTSSettings } from '../../types';

interface TTSState {
  text: string;
  settings: TTSSettings;
  processing: boolean;
  audioUrl: string | null;
  error: string | null;
}

const initialState: TTSState = {
  text: '',
  settings: {
    speed: 1,
    pitch: 1,
    volume: 1,
    format: 'mp3',
  },
  processing: false,
  audioUrl: null,
  error: null,
};

const ttsSlice = createSlice({
  name: 'tts',
  initialState,
  reducers: {
    setText: (state, action: PayloadAction<string>) => {
      state.text = action.payload;
    },
    setSettings: (state, action: PayloadAction<Partial<TTSSettings>>) => {
      state.settings = { ...state.settings, ...action.payload };
    },
    setProcessing: (state, action: PayloadAction<boolean>) => {
      state.processing = action.payload;
    },
    setAudioUrl: (state, action: PayloadAction<string | null>) => {
      state.audioUrl = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    resetState: (state) => {
      state.text = '';
      state.audioUrl = null;
      state.error = null;
      state.processing = false;
    },
  },
});

export const {
  setText,
  setSettings,
  setProcessing,
  setAudioUrl,
  setError,
  resetState,
} = ttsSlice.actions;
export default ttsSlice.reducer;